import { watch } from "vue";
import { t } from "@/controllerLK/GlobusLocalization";
export default function useCommonChart(chartOptions, categories, series) {

  function updateOptions(customOptions) {
    chartOptions.value = {
      ...chartOptions.value,
      ...customOptions
    };
  }

  watch(
    () => [categories, series],
    () => {
      if(!categories?.value?.length) {
        updateOptions({noData: {text: t("common_chart.no_data.text")}});
      } else {
        updateOptions();        
      }
    },
    {deep: true}
  );
  
  return {
    updateOptions
  };
}